<template>
  <div class="open-confirm">
    <!--标题栏-->
    <app-header class="app-header" title="申请开通项目" @goback="goBack"></app-header>
    <div class="order-content">
      <div class="order-box" v-for="(item, moduleIndex) in moduleOrderList" :key="moduleIndex">
        <div class="module-title">{{item.name}}</div>
        <ul class="product-content">
          <li v-for="(product, index) in item.list" :key="index">
            <div class="product-title">{{product.productName}}</div>
            <div class="product-mes">
              <span>门店数量:</span>
              <cube-input type="number" class="cube-input" v-model="product.storeNumber" @change="bindShoppingCart(product)"></cube-input>
              <span>购买时长:</span>
              <cube-input type="number" class="cube-input" v-model="product.duration" @change="bindShoppingCart(product)"></cube-input>
            </div>
            <div class="product-btn">
              <span @click="deleteProduct(product, moduleIndex, index)">删除</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="order-btn-box">
      <div class="btn-cancel" @click="cancelApply">取消申请</div>
      <div class="btn-submit" @click="commitApply">提交申请</div>
    </div>
  </div>
</template>

<script>
import AppHeader from 'components/app-header';
import apis from 'api/index';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { Style, Input, Toast } from 'cube-ui';

export default {
  components: {
    AppHeader,
    cubeInput: Input,
  },
  data() {
    return {
      moduleOrderList: [],
    }
  },
  computed: {
    ...mapGetters(['shoppingCart'])
  },
  created() {
    this.fetchModuleList();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    bindShoppingCart(product) {
      this.changeValueOfShop(product);
    },
    deleteProduct(product, moduleIndex, index) {
      // 先修改当前moduleOrderList 
      this.moduleOrderList[moduleIndex].list.splice(index, 1);
      if(this.moduleOrderList[moduleIndex].list.length === 0) {
        this.moduleOrderList.splice(moduleIndex, 1);
      }
      // 再修改购物车里的值
      this.deleteValueOfShop(product);
    },
    cancelApply() {
      this.$router.go(-1);
    },
    async commitApply() {
      try {
        let moduleOrders = this.shoppingCart.map(item => {
          return {
            moduleId: item.moduleId,
            moduleName: item.moduleName,
            productId: item.id,
            productName: item.productName,
            chargeType: item.chargeType,
            num: item.storeNumber,
            duration: item.duration,
            productType: item.productType,
            deptType: item.deptType
          }
        });
        let params = {
          orderType: 1,
          moduleOrders: moduleOrders
        };
        const res = await apis.openModuleOrder(JSON.stringify(params));
        this.showToast('申请成功');
        // 清空购物车和列表
        this.moduleOrderList = [];
        this.changeShoppingCart([]);
        // this.$router.push({name: 'open-list'});
      } catch(err) {
        console.error(err);
      }
    },
    // 获取模块列表,并注入模块对应的产品
    async fetchModuleList() {
      try {
        const res = await apis.getModuleList();
        this.moduleOrderList = this._normalizeModuleOrder(res);
      } catch(err) {
        console.error(err);
      }
    },
    showToast(text) {
      const toast = this.$createToast({
        txt: text,
        type: 'correct'
      });
      toast.show();
    },
    _normalizeModuleOrder(data) {
      return data.map(item => {
        let list = this.shoppingCart.filter(list => list.moduleId === item.id);
        if (list.length === 0) {
          return false;
        }
        return {
          id: item.id,
          name: item.name,
          list: list,
        }
      }).filter(moudle => moudle);
    },
    ...mapActions(['changeValueOfShop', 'deleteValueOfShop']),
    ...mapMutations(['changeShoppingCart'])
  }
}
</script>

<style lang="scss" scoped  src="./open.scss"></style>

